// Generates a consistent color for any user, regardless of which page they're on
export function getUserColor(userName) {
  if (!userName) return '#256f65'; // fallback color
  
  // Create a hash of the user name
  let hash = 0;
  for (let i = 0; i < userName.length; i++) {
    hash = ((hash << 5) - hash) + userName.charCodeAt(i);
    hash = hash & hash; // Convert to 32bit integer
  }
  
  // Predefined palette of distinct colors
  const colors = [
    '#5b6ee1', // indigo
    '#ec4899', // pink
    '#f97316', // orange
    '#06b6d4', // cyan
    '#8b5cf6', // violet
    '#10b981', // emerald
    '#f43f5e', // rose
    '#6366f1', // indigo-500
    '#14b8a6', // teal
    '#d97706', // amber
  ];
  
  return colors[Math.abs(hash) % colors.length];
}